angular.module('mercury.modules.settings.company')
.config(["$stateProvider", function($stateProvider) {

  $stateProvider.state('Settings.CompanyList', {
    url: '/company',
    controller: 'SettingsCompanyListCtrl',
    templateUrl: 'modules/settings/company/list.tpl.html'
  });

  $stateProvider.state('Settings.NewCompany', {
    url: '/company/newcompany',
    controller: 'SettingsNewCompanyCtrl',
    templateUrl: 'modules/settings/company/newcompany.tpl.html'
  });

  $stateProvider.state('Settings.CompanyEdit', {
    url: '/company/edit/:id',
    controller: 'SettingsCompanyEditCtrl',
    templateUrl: 'modules/settings/company/edit.tpl.html'
  });

  $stateProvider.state('Settings.CompanyPreferences', {
    url: '/company/preferences/:id',
    controller: 'SettingsCompanyPreferencesCtrl',
    templateUrl: 'modules/settings/company/preferences.tpl.html'
  });

  $stateProvider.state('Settings.CompanyOutlets', {
    url: '/company/outlets/:id',
    controller: 'SettingsCompanyOutletsCtrl',
    templateUrl: 'modules/settings/company/outlets.tpl.html'
  });

  $stateProvider.state('Settings.CompanyImporter', {
    url: '/company/importer',
    templateUrl: 'modules/settings/company/importer.tpl.html',
    controller: 'SettingsCompanyImporterCtrl'
  });

  $stateProvider.state('Settings.CompanyExpired', {
    url: '/company/expired',
    templateUrl: 'modules/settings/company/expired.tpl.html',
    controller: 'SettingsCompanyExpiredCtrl'
  });

  $stateProvider.state('Settings.CompanyAcceptOwnership', {
    url: '/company/acceptownership/:id',
    templateUrl: 'modules/settings/company/acceptownership.tpl.html',
    controller: 'SettingsCompanyAcceptOwnershipCtrl'
  });

  $stateProvider.state('Settings.Subscription', {
    url: '/company/subscription/:id',
    templateUrl: 'modules/settings/company/subscription.tpl.html',
    controller: 'SettingsCompanySubscriptionCtrl'
  });

  $stateProvider.state('Settings.Privacy', {
    url: '/company/privacy',
    templateUrl: 'modules/settings/company/privacy.tpl.html'
  });

  $stateProvider.state('Settings.Eula', {
    url: '/company/eula',
    templateUrl: 'modules/settings/company/eula.tpl.html'
  });

  // React routes below
  $stateProvider.state('Settings.RevenueGroups', {
    url: '/company/revenue-groups',
    controller: 'ReactCtrl'
  });

  $stateProvider.state('Settings.CompanyPreferencesReact', {
    url: '/company/preferences',
    controller: 'ReactCtrl'
  });
}]);
